import { type ReactNode } from 'react';

import styles from './Layout.module.scss';

const SuccessLayout = ({ children }: { children: ReactNode }) => (
  <div className={styles.successWrapper}>
    <img
      src="/images/new-order/success-screen-combined-bg.svg"
      width="1926"
      height="1341"
      alt=""
      className={styles.successWrapperBg}
    />

    <div className={styles.outerContainer}>
      <header className={styles.header}>
        <a href="https://clearvpn.com/">
          <img
            src="/images/logo-horizontal-white.png"
            srcSet="/images/logo-horizontal-white@2x.png 2x"
            width="87px"
            height="24px"
            alt="ClearVPN"
          />
        </a>
      </header>
      {children}
    </div>
  </div>
);

export default SuccessLayout;
